import axios from "axios";

export const uriPrefix = import.meta.env.DEV ? import.meta.env.VITE_SERVER_URI : (window.__env?.SERVER_URI ?? "%SERVER_URI%");

// eslint-disable-next-line import/no-named-as-default-member
export const axiosInstance = axios.create({
  baseURL: typeof uriPrefix === "string" ? uriPrefix.replace(/\/$/, "") : "",
});
